/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { TranslatedSentence } from './translated-sentence';

/**
 *
 * @export
 * @interface AddPartialTranslation
 */
export interface AddPartialTranslation {
  /**
   *
   * @type {string}
   * @memberof AddPartialTranslation
   */
  message: AddPartialTranslationMessageEnum;
  /**
   * Speechmatics JSON output format version number.
   * @type {string}
   * @memberof AddPartialTranslation
   */
  format?: string;
  /**
   *
   * @type {string}
   * @memberof AddPartialTranslation
   */
  language: string;
  /**
   *
   * @type {Array<TranslatedSentence>}
   * @memberof AddPartialTranslation
   */
  results: Array<TranslatedSentence>;
}

export const AddPartialTranslationMessageEnum = {
  AddPartialTranslation: 'AddPartialTranslation',
} as const;

export type AddPartialTranslationMessageEnum =
  (typeof AddPartialTranslationMessageEnum)[keyof typeof AddPartialTranslationMessageEnum];
